<template>
  <v-app class="app">
    <div>
      <context-view :visible="contextViewVisible" />
      <!-- 'router-view' is a "global" component that is injected into the Vue component registry by vue-router. -->
      <router-view v-if="!languageIsChanging" />
      <div v-if="languageIsChanging" class="alert alert-info">Language is changing...</div>
      <auth-debug v-if="challengerEnv.debugMode" />
    </div>
  </v-app>
</template>

<script>
import ContextView from './ContextView';
import AuthDebug from './auth/AuthDebug';
import axios from 'axios';
import { initGlobalErrorHandlers } from '@/globalHandler';
export default {
  name: 'AppRoot',
  data() {
    return {
      languageIsChanging: false,
      contextViewVisible: false,
      challengerEnv: this.$envConfig,
      axios,
    };
  },
  methods: {
    changeAppLanguage(language) {
      // Changing languages is an async action, therefore the `languageIsChanging` property can be used
      // to show a loading/switching screen when language is being changed.
      const i18n = this.$i18n.i18next;
      if (i18n.language !== language) {
        this.languageIsChanging = true;

        i18n.changeLanguage(language, () => {
          this.languageIsChanging = false;
        });
      }
    },
    toggleContextView() {
      this.contextViewVisible = !this.contextViewVisible;
    },
  },
  mounted: function () {
    
    if(this.$auth) {
      initGlobalErrorHandlers();
      const tokenManager = this.$auth.getTokenManager();
      const self = this;
      // Triggered when a token has expired
      tokenManager.on('expired', function (key, expiredToken) {
      if(self.$logger !=null && typeof(self.$logger)!=='undefined'){
        self.$logger.debug('Token with key' + key + ' has expired:');
        self.$logger.debug('Expired: %o', expiredToken);
        }
        try {
          if (typeof Storage !== 'undefined' && typeof(window)!='undefined') {
            sessionStorage.setItem(
              'implicitCallbackRedirect',
              JSON.stringify(window.location.pathname)
            );
            // this will redirect to OKTA - use prompt none to make sure we are not getting stuck on OKTA login page...
            // if the renew token was success then it will get back to the implicit call back page
            // if the renew token failed due to session timeout on OKTA - then it will get back to login
            self.$auth.oktaAuth.token.getWithRedirect({prompt: 'none'});
          }
          self.$router.push('/login');
        } catch (ex) {
        if(self.$logger !=null && typeof(self.$logger)!=='undefined'){
          self.$logger.error('TokenManager Expire exception - ',ex);
          }
          self.$router.push('/login');
        }
      });
    }
  },
  provide() {
    // Use Vue's provide/inject capabilities to "provide" functions to
    // any descendant component that want to use/"inject" the functions.
    return {
      changeAppLanguage: this.changeAppLanguage,
      toggleContextView: this.toggleContextView,
    };
  },
  components: {
    ContextView,
    AuthDebug,
  },
};
</script>
